module.exports = __webpack_public_path__ + "media/images/logos/The_Grio-fb23aaec1a8d6bec266b667910f98685.png";